import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Button,
  TablePagination,
  CircularProgress,
  Box,
  IconButton,
  Checkbox,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  Add,
  DeleteForever,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Remove,
  Sell,
  UnfoldMore,
} from "@mui/icons-material";
import moment from "moment/moment";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  "& svg": {
    position: "relative",
    top: "5px",
  },
  "&:last-child": {
    // paddingRight: 64,
    "& svg": {
      // display: 'none',
      // color: theme.palette.primary.dark
    },
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const QuantityBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export default function TableComponentPickup({
  productQuantity,
//   setProductQuantity,
  check,
  setCheck,
  handleChange,
  handleCheck,
  handleAddQuantity,
  handleRemoveQuantity,
  rows,
  columns,
  footer,
  modifiedData,
  setModifiedData,
  handleRemoveFromCart,
}) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  
  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = "https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png";
  }


  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {columns.map((col, index) => (
                <StyledTableCell align={index === 0 ? "left" : "center"}>
                  {col.name}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          {rows && rows.length > 0 ?
          <TableBody>
            {rows && rows 
            //   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
               
                var curr = {};
                modifiedData.length > 0 && modifiedData.map(m => {
                    if(m.id === row.productID){
                        curr = m;
                }})

                return(
                
                <StyledTableRow key={Math.random()}>
                  {columns.map((col, index) =>
                    col.id === "imageUrl" ? (
                      <StyledTableCell align="left">
                        <img
                          src={row?.ax_relation?.imageUrl || "https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png"}
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                          }}
                          // alt={row.ax_relation.ItemName}
                          alt={`image_${row.productID}`}
                          onError={handleImageError}
                        />
                      </StyledTableCell>
                    //  ) 
                    // : col.id === "check" ? (
                    //   <StyledTableCell component="th" scope="row">
                    //     <Checkbox
                    //       checked={modifiedData && modifiedData.map((mod) => {
                    //         if(mod.id == row.id){
                    //             return mod.check
                    //         }else{
                    //             return false
                    //         }
                    //       }
                    //       )}
                    //       value={modifiedData && modifiedData.map((mod) => {
                    //         if(mod.id == row.id){
                    //             return mod.check
                    //         }else{
                    //             return false
                    //         }
                    //       }
                    //       )}
                    //       defaultChecked={false}
                    //       onChange={(e) => handleCheck(e, row)}
                    //     />
                    //   </StyledTableCell>
                     ) 
                    : col.id === "check" ? (
                      <StyledTableCell component="th" scope="row">
                        <Tooltip title="Delete">
                          <DeleteForever
                            sx={{ fontSize: '30px' }}
                            color="secondary"
                            variant="contained"
                            cursor="pointer"
                            onClick={() => handleRemoveFromCart(row.productID)}
                          />
                        </Tooltip>
                         </StyledTableCell>
                    
                    ) : col.id === "quantity" ? (
                      <StyledTableCell>
                        <div
                          style={{
                            display:"flex",
                            height:"50px",
                            alignItems: "center",
                            justifyContent: "center",
                            background:
                              parseInt(row?.quantity || row?.amount) == curr?.productQuantity 
                                ? "#d1ffbd"
                                : "#ffcccb",
                          }}
                        >
                          {parseInt(row?.quantity || row?.amount)}
                        </div>
                      </StyledTableCell>
                    ) : col.id == "ItemName" ? (
                      <StyledTableCell component="th" scope="row">
                        {row?.ax_relation?.ItemName}
                      </StyledTableCell>
                    ) : col.id == "EANBarcode" ? (
                      <StyledTableCell component="th" scope="row">
                        {row?.ax_relation?.EANBarcode}
                      </StyledTableCell>
                    ) : col.id == "SizeID" ? (
                      <StyledTableCell component="th" scope="row">
                        {row?.ax_relation?.SizeID}
                      </StyledTableCell>
                    ) : col.id === "confirm" ? (
                      <StyledTableCell>
                        <QuantityBox>
                          <IconButton onClick={() => handleRemoveQuantity(row)}>
                            <Remove />
                          </IconButton>
                          <TextField
                            name="productQuantity"
                            type="number"
                            variant="outlined"
                            defaultValue={0}
                            value={
                              curr.productQuantity === 0
                                ? 0
                                : curr.productQuantity || 1
                            }
                            onChange={(e) => handleChange(e, row)}
                            style={{ width: "100px" }}
                            InputProps={{
                              inputProps: {
                                max: parseInt(row?.quantity || row?.amount),
                                min: 0,
                              },
                            }}
                          />
                          <IconButton onClick={() => handleAddQuantity(row)}>
                            {" "}
                            <Add />{" "}
                          </IconButton>
                        </QuantityBox>
                      </StyledTableCell>
                    ) : col.id == "action" ? (
                      <StyledTableCell align="left">
                        <>
                          <Button
                            color="primary"
                            variant="outlined"
                            // onClick={() => handleResume(row)}
                          >
                            Pickup
                          </Button>
                        </>
                      </StyledTableCell>
                    ) : (
                      <StyledTableCell component="th" scope="row">
                        {row[col.id]}
                      </StyledTableCell>
                    )
                  )}
                </StyledTableRow>
              )})}
          </TableBody>
          :
          <TableBody>
            {/* <StyledTableRow> */}
              <StyledTableCell component="th" scope="row">
                No Items to Pick up!
              </StyledTableCell>
             
            {/* </StyledTableRow> */}
          </TableBody>
          }
        </Table>
      </TableContainer>
      {/* {footer !== false && (
        <TablePagination
          rowsPerPageOptions={[10, 20, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )} */}
    </Paper>
  );
}
